var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.itemComponents.length > 0
        ? [
            _vm._l(_vm.itemComponents, function(component) {
              return [
                _c("manufacturer-details", {
                  attrs: {
                    manufacturer: component.manufacturer,
                    "concatenated-names": component.concatenatedNames,
                    "visible-fields": _vm.visibleFields
                  }
                }),
                _vm._v(" "),
                _c("hr")
              ]
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }